import { render, staticRenderFns } from "./EndpointForm.vue?vue&type=template&id=354f836f&"
import script from "./EndpointForm.vue?vue&type=script&lang=js&"
export * from "./EndpointForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports